import React, { useState } from 'react';
import Button from '@mui/material/Button';


import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


function DialogX(props) {
  
    
    const handleOK = () => {
        
        props.onCompletionFunc(true); //calls the parent component's onCompletion function with the dialog result

        handleClose();
    };


    const handleCancel = () => {
      
      props.onCompletionFunc(false); //calls the parent component's onCompletion function with the dialog result

      handleClose();
  };

    const handleClose = () => {

        props.setDialogOpen(false);
    };

    


  

  return (
    <div>      
    
      <Dialog open={true} onClose={handleClose}  aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Bekreft</DialogTitle>
        <DialogContent>

          <DialogContentText>
            {props.dialogText}
          </DialogContentText>
          
        </DialogContent>

        <DialogActions>          
          <Button onClick={handleCancel} color="primary">
            Avbryt
          </Button>
          <Button onClick={handleOK} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default DialogX;